import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M12 6v6l2 1', key: '19cm8n' }],
  ['path', { d: 'M13.5 21.885A10 10 0 1 1 22 12', key: 'xgp8as' }],
  ['path', { d: 'M14 18h8', key: '1le3fr' }],
  ['path', { d: 'm18 22 4-4-4-4', key: 'mordo3' }],
];

/**
 * @component @name ClockArrowRight
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNnY2bDIgMSIgLz4KICA8cGF0aCBkPSJNMTMuNSAyMS44ODVBMTAgMTAgMCAxIDEgMjIgMTIiIC8+CiAgPHBhdGggZD0iTTE0IDE4aDgiIC8+CiAgPHBhdGggZD0ibTE4IDIyIDQtNC00LTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/clock-arrow-right
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ClockArrowRight = createLucideIcon('clock-arrow-right', __iconNode);

export default ClockArrowRight;
